import { StyledText } from '@clickcease/cc-client-components-lib'

import { PlatformIcons } from '../../../../../components/Elements/Icons/PlatformsIcons'
import { Platforms } from '../../../models'
import React from 'react'

import { ConnectionOption, MiddleTextMargins } from './ConnectionOptions.styled'

export const PlatformConnectOption = ({
  onClick,
  platform,
  title,
  description,
}: {
  onClick: () => void
  platform: Platforms
  description: string
  title: string
}) => {
  return (
    <ConnectionOption onClick={onClick}>
      <PlatformIcons serviceName={platform} iconProps={{ width: '16px', height: '16px' }} />
      <MiddleTextMargins>
        <StyledText variant={'largeBold'}>{title}</StyledText>
      </MiddleTextMargins>
      <StyledText variant={'baseLight'} css={{ width: '250px', textAlign: 'center' }}>
        {description}
      </StyledText>
    </ConnectionOption>
  )
}
